import axios from 'axios';

/**
 * 上传文件到后端本地存储
 * @param {File} file 文件对象
 * @param {string} folderName 文件夹名称（必填，如 clockIn）
 * @param {string} fileName 自定义文件名（必填，不含扩展名）
 * @returns {Promise<string>} 返回文件访问 URL
 */
export function uploadFile(file, folderName, fileName) {
  return new Promise((resolve, reject) => {
    if (!file) return reject(new Error('请提供文件'));
    if (!folderName) return reject(new Error('请提供 FolderName'));
    if (!fileName) return reject(new Error('请提供 FileName'));

    const formData = new FormData();
    formData.append('file', file);

    const token = localStorage.getItem('access_token')
    const headers = {
      'Content-Type': 'multipart/form-data'
    }
    if (token) {
      headers.Authorization = 'Bearer ' + token
    }

    axios.post(
      `https://pinche.jafron.com/api/FileStore/FileUpload?FolderName=${folderName}&FileName=${fileName}`,
      formData,
      { headers }
    )
    .then(res => {
      if (res.data.success && res.data.data) {
        resolve(res.data.data.fileUrl);
      } else {
        reject(new Error(res.data.message || '上传失败'));
      }
    })
    .catch(err => {
      console.error('上传文件出错:', err);
      reject(err);
    });
  });
}
